<span>{{ label ? label + ':' : '' }} {{ value }}</span>
